import React, { useState, useEffect } from "react";
import Button from "sushiweb/Button";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import PolygonList from "../../components/Polygon/PolygonList";
import PolygonFormModal from "../../components/Polygon/PolygonFormModal";
import ListPagination from "../../components/Common/ListPagination";
import * as PolygonActions from "../../store/actions/Polygon";
import Permission from "../../components/Common/Permission";
import MenuNames from "../../constants/Menu/MenuNames.json";
import MenuActionsMappings from "../../constants/Menu/MenuActionsMappings";
import { getPath } from "../../utils";
import FilterButton from "../../components/Common/FilterButton";
import { FlexContainer, Heading } from "../../constants/assets/containers";
import { useHistory, useParams } from "react-router";

const Polygon = (props) => {
  const params = useParams();
  const history = useHistory();
  const [modalState, setModalState] = useState(false);
  const [activeRefId, setActiveRefId] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const allActions = MenuActionsMappings[MenuNames.POLYGON];

  const filterFields = ["polygon.city_id", "polygon.ref_id"];
  const shouldRenderList =
    getPath(params, "id", undefined) === undefined ? true : false;

  const handleClick = (type, refId) => {
    setModalState(type);
    setActiveRefId(refId);
  };

  const handleClose = () => {
    setModalState(false);
    setActiveRefId("");
    props.resetState({ state: "activePolygon" });
    if (history.location.pathname !== "/polygons") {
      history.push("/polygons");
    }
  };

  // handle pagination
  const handleNavClick = (action) => {
    const pageRequest = { page: currentPage };
    if (action === "prev") {
      pageRequest.page = currentPage - 1;
    } else {
      pageRequest.page = currentPage + 1;
    }
    setCurrentPage(pageRequest.page);
    props.getPolygonList(props.activeFilters, pageRequest);
  };

  const getModal = () => {
    const defaultProps = {
      activeRefId: activeRefId,
      modalState: modalState,
      handleClose: handleClose,
      cityList: props.cityList,
      polygonTypes: props.polygonTypes,
    };

    switch (modalState) {
      case "Add":
      case "Edit":
        return <PolygonFormModal {...defaultProps} />;
      case "Filter":
        return (
          <PolygonFormModal {...defaultProps} filterFields={filterFields} />
        );
      default:
        return;
    }
  };

  useEffect(() => {
    if (shouldRenderList === true) {
      props.getPolygonList();
    } else {
      handleClick("Edit", params.id);
    }
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [JSON.stringify(props.activeFilters)]);

  return (
    <div className="Polygon-View container">
      <FlexContainer align="flex-start">
        <Heading>Polygons</Heading>
        <div className="actionBar mb-20 flex items-center justify-end">
          <Permission requiredPerms={[allActions.LIST]}>
            <FilterButton
              activeFilters={props.activeFilters}
              handleClick={() => handleClick("Filter", null)}
            />
          </Permission>
          <Permission requiredPerms={[allActions.CREATE]}>
            <Button
              onClick={() => handleClick("Add", null)}
              className="sushi-btn ml-12"
              data-testid="PolygonsAddBtn"
            >
              Add New
            </Button>
          </Permission>
        </div>
      </FlexContainer>
      <Permission requiredPerms={[allActions.LIST]}>
        <PolygonList polygonList={props.polygonList} />
        <ListPagination
          nextPage={props.nextPage}
          prevPage={props.prevPage}
          handleNavClick={handleNavClick}
        />
      </Permission>
      {modalState && getModal()}
    </div>
  );
};

const mapStateToProps = (state) => {
  const { Polygon } = state;
  return {
    polygonList: Polygon.polygonList,
    nextPage: Polygon.nextPage,
    prevPage: Polygon.prevPage,
    activeFilters: Polygon.activeFilters,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getPolygonList: bindActionCreators(
      PolygonActions.getPolygonList,
      dispatch
    ),
    resetState: bindActionCreators(PolygonActions.resetState, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Polygon);
